import { PageCollection } from "shared/models/PageCollection";
import { Params } from "react-router-dom";
import { SearchEntityTypeEnum } from "view360Card/models";

export const getEntityIdParamValue = (params: Readonly<Params<string>>) => params[routeParams.id.replace(":", "")] ?? "";

export const getLinkToEntity = (entityType: SearchEntityTypeEnum, entityId: number) => {
    let path = "";

    if (entityType === SearchEntityTypeEnum.Intermediary) {
        path = pages.view360GeneralInformationTabIntermediary.path;
    }

    if (entityType === SearchEntityTypeEnum.SalesPerson) {
        path = pages.view360GeneralInformationTabSalesPerson.path;
    }

    return path.replace(routeParams.id, entityId.toString());
}

export const getEntityTypeFromPath = (locationPath: string) => {
    if (locationPath.startsWith('/pages/view-360/intermediary/')) {
        return SearchEntityTypeEnum.Intermediary;
    }
    return SearchEntityTypeEnum.SalesPerson;
} 

export const routeParams = {
    id: ":id",
  };

const pages : PageCollection = {
    root: {
        path: "/",
        displayName: "Strona główna",
    },
    homePage: {
        path: "/pages/goals-card/monthly",
        displayName: "Karta celów - miesięczna",
    },
    goalsMonthly: {
        path: "/pages/goals-card/monthly",
        displayName: "Karta celów - miesięczna",
    },
    goalsQuarterly: {
        path: "/pages/goals-card/quarterly",
        displayName: "Karta celów - kwartalna",
    },
    goalsMonthlyRms: {
        path: "/pages/goals-card/monthly-rms",
        displayName: "Karta celów - miesięczna RMS",
    },
    motivationMonthly: {
        path: "/pages/motivation-card/monthly",
        displayName: "Karta motywacji - miesięczna",
    },

    motivationQuarterly: {
        path: "/pages/motivation-card/quarterly",
        displayName: "Karta motywacji - kwartalna",
    },
    tasks: {
        path: "/pages/tasks",
        displayName: "Zadania",
    },
    powerBiReports: {
        path: "/pages/power-bi-reports",
        displayName: "Raporty PowerBI",
    },
    globalNotes: {
        path: "/pages/global-notes",
        displayName: "Notatki",
    },
    view360: {
        path: "/pages/view-360",
        displayName: "Widok 360 - Search",
    },
    view360GeneralInformationTabIntermediary: {
        path: `/pages/view-360/intermediary/${routeParams.id}/general-information`,
        displayName: "Widok 360 - Informacje Ogólne",
    },
    view360EmployeesListIntermediary: {
        path: `/pages/view-360/intermediary/${routeParams.id}/employees`,
        displayName: "Widok 360 - OFWCA",
    },
    view360SalesTabIntermediary: {
        path: `/pages/view-360/intermediary/${routeParams.id}/sales`,
        displayName: "Widok 360 - Sprzedaż",
    },
    view360NotesTabIntermediary: {
        path: `/pages/view-360/intermediary/${routeParams.id}/notes`,
        displayName: "Widok 360 - Historia Kontaktów",
    },
    view360GeneralInformationTabSalesPerson: {
        path: `/pages/view-360/sales-person/${routeParams.id}/general-information`,
        displayName: "Widok 360 - Informacje Ogólne",
    },
    view360SalesTabSalesPerson: {
        path: `/pages/view-360/sales-person/${routeParams.id}/sales`,
        displayName: "Widok 360 - Sprzedaż",
    },
    view360NotesTabSalesPerson: {
        path: `/pages/view-360/sales-person/${routeParams.id}/notes`,
        displayName: "Widok 360 - Historia Kontaktów",
    },
    rmsPortal: {
        path: "/pages/rms-portal",
        displayName: "Portal RMS",
    },
    userProfileAdministration: {
        path: "/pages/user-profile",
        displayName: "Administracja"
    }
};

export default pages;
